import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { CartPageComponent } from './cart-page/cart-page.component';
import { CheckOutComponent } from './cart-page/check-out/check-out.component';
import { HomeComponent } from './home/home.component';
import { ProductPageComponent } from './product-page/product-page.component';


const routes: Routes = [
  {path : '', redirectTo : 'products',pathMatch :"full"},
  {path : 'home', component : HomeComponent},
  {path : 'products', component : ProductPageComponent},
  {path : 'cart', component : CartPageComponent},
  {path : 'check-out', component : CheckOutComponent},
  {path : 'admin', component : AdminComponent},
  ];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
